/** Keep follow state in sync across Feed spotlight, profile modal, members sheet, etc. */
export function notifyFollowingChanged(memberId: string, following: boolean) {
  window.dispatchEvent(new CustomEvent('bagtag:following-changed', { detail: { memberId, following } }));
}
